<template>
    <TopContainer :score="scoreData">
        <div>
            <!-- <div class="DEBUG">
                <button @click.prevent="onPrevious"><<<</button>
                <button @click.prevent="onNext">>>></button>
            </div> -->
            <div :class="currentComponent">
                <component :is="currentComponent" :data="data" @next="onNext" @answer="onAnswer" @complete="onComplete"></component>
            </div>

            <div class="reaction-video-wrapper" v-show="displayReaction">
                <video ref="video" id="video" style="display: none;" preload="auto" playsinline muted>
                    <source ref="videoSource" src="./video/feedback/guusfeedback_klappen_wijzen.mp4" type="video/mp4;">
                </video>
                <canvas ref="buffer" id="buffer" style="display: none;" :width="width" :height="height * 2"></canvas>
                <canvas class="reaction-video" ref="output" id="output" :width="width" :height="height"></canvas>
            </div>
        </div>
    </TopContainer>
</template>

<script>
    import Auth from '../services/Auth';
    import Audio from '../services/Audio';
    import Backend from '../services/Backend';
    import AssignmentState from '../services/AssignmentState';
    import OrchestrationManager from '../services/OrchestrationManager';

    import TopContainer from './TopContainer.vue';

    import MultipleChoiceModule from './modules/MultipleChoiceModule.vue';
    import TextModule from './modules/TextModule.vue';
    import MovieplayerModule from './modules/MovieplayerModule.vue';
    import InteractiveVideoModule from './modules/InteractiveVideoModule.vue';
    import SelfTestModule from './modules/SelfTestModule.vue';

    import BalloonTest from './modules/games/BalloonAnalogueRiskTask.vue';
    import CardSorting from './modules/games/CardSorting.vue';
    import TowerOfHanoi from './modules/games/TowerOfHanoi.vue';

    export default {
        'components': {
            TopContainer,
            MultipleChoiceModule,
            TextModule,
            MovieplayerModule,
            InteractiveVideoModule,
            SelfTestModule,
            BalloonTest,
            CardSorting,
            TowerOfHanoi,
        },
        'props': {
            code: {
                type: String,
                default: undefined,
            },
            index: false,
        },
        'data': function () {
            return { 
                assignmentTitle: '',
                currentComponent: '',
                data: {},
                loading: true,
                scoreData: {
                    correct: 0,
                    incorrect: 0,
                    questionCount: 0,
                    progress: 0,
                },
                gameCompleted: false,
                displayReaction: false,
                outputCanvas: null,
                output: null,
                bufferCanvas: null,
                buffer: null,
                video: null,
                width: 0,
                height: 0,
                interval: null,
                autoContinue: false,
            }
        },
        'watch': {
            code: {
                handler(newVal, oldVal) {
                    this.loading = true;
                    this.load();
                    this.gameCompleted = false;
                    this.state.start(this.code).then(() => {
                        this.loading = false;
                        this.processScoreData();
                    });
                }
            }
        },
        'methods': {
            'initVideo': function () {
                this.outputCanvas = this.$refs.output;
                this.output = this.outputCanvas.getContext('2d');
                this.bufferCanvas = this.$refs.buffer;
                this.buffer = this.bufferCanvas.getContext('2d');
                this.video = this.$refs.video;

                this.video.addEventListener("ended", () => {
                    this.displayReaction = false;

                    if(this.autoContinue) {
                        this.autoContinue = false;
                        this.onNext();
                    }
                });

                clearInterval(this.interval);
                this.interval = setInterval(this.processFrame, 40);
            },
            'setReactionVideo': function () {
                if(this.currentComponent == "SelfTestModule") {
                    this.$refs.videoSource.src = "./video/feedback/guusfeedback_skills.mp4";
                } else {
                    this.$refs.videoSource.src = "./video/feedback/guusfeedback_klappen_wijzen.mp4";
                }

                this.$refs.video.load();
            },
            'processFrame': function () {
                if(!this.video || this.video.paused) {
                    return;
                }

                this.width = this.video.videoWidth;
                this.height = this.video.videoHeight / 2;
                this.buffer.drawImage(video, 0, 0);
                
                var image = this.buffer.getImageData(0, 0, this.width, this.height),
                    imageData = image.data,
                    alphaData = this.buffer.getImageData(0, this.height, this.width, this.height).data;

                for (var i = 3, len = imageData.length; i < len; i = i + 4) {
                    imageData[i] = alphaData[i-1];
                }

                this.output.putImageData(image, 0, 0, 0, 0, this.width, this.height);
            },
            'log': function(msg) {
                console.log(msg);
            },
            'onComplete': function(autoContinue = false) {
                if(!this.gameCompleted) {
                    this.displayReaction = true;
                    this.video.play();
                    Audio.playSFX('welldone');
                    this.gameCompleted = true;
                    this.autoContinue = autoContinue;
                }
            },
            'onPrevious': function() {
                if (!this.state.previous()) { }
                this.processScoreData();
            },
            'onNext': function() {
                if (!this.state.next()) {
                    this.state.finish();
                    this.onFinished();
                }
                this.processScoreData();
            },
            'onFinished': function() {
                if (this.code == "assessment") {
                    this.$router.push({ name: 'editprofile'});
                } else if (this.code.includes('COURSE-END')) {
                    this.$router.push({ name: 'landing' });
                } else {
                    this.$router.push({ name: 'assignmentgrid' });
                }  
            },
            'onAnswer': function(answer) {
                //console.log('answer', answer);
                Backend.MIA.updateAssignmentSessionAsnwers(this.code, this.state.getService().session.id, answer);
                this.state.setAnswer(answer);
            },
            'getProgress': function() {
                if(!this.state)
                    return 0;

                return Math.round((this.state.getActiveSegmentIndex() / this.state.getSegmentsLength()) * 100);
            },
            'processScoreData': function() {
                this.scoreData.correct = 0;
                this.scoreData.incorrect = 0;
                this.scoreData.questionCount = 0;

                let activeSegmentIndex = this.state.getActiveSegmentIndex();
                let segmentsLength = this.state.getSegmentsLength();
                this.scoreData.progress = activeSegmentIndex / segmentsLength;

                let segments = this.state.getSegments();
                for (let segment of segments) {
                    if(!segment.segment.data.answer)
                        continue;
                    
                    let selectedChoice = segment.segment.data.question.choices.find((choice) => {
                        return choice.id === segment.segment.data.answer.answerParts[0].answerId;
                    });

                    if(selectedChoice.isCorrect) {
                        this.scoreData.correct++;
                    } else {
                        this.scoreData.incorrect++;
                    }

                    if(segment.segment.data.question.id === this.data.question.id) {
                        this.data = Object.assign({}, this.data, { selectedChoice: selectedChoice });
                    }
                }

                // Trigger vue react
                this.scoreData = Object.assign({}, this.scoreData);

                this.$store.commit('setHeaderData', Object.assign({ }, this.scoreData));
            },
            'load': function() {
                this.state = new AssignmentState({
                    'load-component': ({component, data}) => {
                        this.assignmentTitle = data.title;
                        this.currentComponent = component;
                        this.data = data;
                        
                        this.gameCompleted = false;
                        this.displayReaction = false;

                        this.processScoreData();
                        this.setReactionVideo();
                        return Promise.resolve();
                    },
                    'finished': () => {
                        this.onFinished();                
                    },
                    'empty': () => {
                        this.onNext();
                        return Promise.resolve();
                    }
                });
            },
            'swipeHandlerToLeft': function() {
// @ifdef DEBUG
                this.onNext();
//// @endif                 
            },
            'swipeHandlerToRight': function() {
// @ifdef DEBUG
                this.onPrevious();
//// @endif                 
            }
        },
        'mounted': function() {
            this.load();

            this.state.start(this.code, this.sessionId, this.index).then(() => {
                this.loading = false;
                //this.processScoreData();
            });

// @ifdef DEBUG
            window.addEventListener('keyup', (e) => {
                if(e.ctrlKey && e.key == "ArrowRight") {
                    this.onNext();
                }
                if(e.ctrlKey && e.key == "ArrowLeft") {
                    this.onPrevious();
                }
            });
//// @endif

            let authoriseVideoElement = () => {
                this.$refs.video.play();
                this.$refs.video.pause();
                
                document.removeEventListener('touchstart', authoriseVideoElement);
            };

            document.addEventListener('touchstart', authoriseVideoElement);

            this.initVideo();
        }
    };
</script>
